import { useApolloClient } from 'react-apollo';

import {
  MessagesMessageThreadMessagesErrorFragment,
  MessagesMessageThreadsQuery,
  MessagesMessageThreadsQueryVariables,
  MessageThreadsErrorFragment,
  MessageThreadsSuccessFragment,
} from 'Src/generated/graphql';

import { GET_MESSAGE_THREADS_QUERY } from '../queries/messageThreads';

function isError(
  messageThreads:
    | MessageThreadsSuccessFragment
    | MessageThreadsErrorFragment
    | undefined
    | null,
): messageThreads is MessagesMessageThreadMessagesErrorFragment {
  return (
    Boolean(messageThreads) &&
    (messageThreads as MessageThreadsErrorFragment).__typename ===
      'GenericError'
  );
}

export default function useMessageThreadsUpdater(
  queryVariables?: MessagesMessageThreadsQueryVariables,
) {
  const client = useApolloClient();

  return function update(
    updater: (
      messageThreadMessages: MessageThreadsSuccessFragment,
    ) => MessageThreadsSuccessFragment,
  ) {
    try {
      const messageThreadsData = client.readQuery<MessagesMessageThreadsQuery>({
        query: GET_MESSAGE_THREADS_QUERY,
        variables: queryVariables,
      });

      if (!messageThreadsData) return;
      const messageThreads = messageThreadsData.messageThreads;

      if (isError(messageThreads)) {
        // handle error
        return;
      }

      const updateValue = updater(messageThreads);

      client.writeQuery<MessagesMessageThreadsQuery>({
        query: GET_MESSAGE_THREADS_QUERY,
        variables: queryVariables,
        data: {
          messageThreads: updateValue,
        },
      });
    } catch (err) {}
  };
}
